// @flow

import type {
  Recommendation,
} from 'hfty-model-recommendations/types'

// Constants
import {
  TREE,
  BRANCH,
} from 'hfty-model-recommendations'

import traverse from 'fc-utils/traverse'

type RecommendationsSelector = (state: Object) => Array<Recommendation>

export default (traverse([TREE, BRANCH]): RecommendationsSelector)
